export default __webpack_public_path__ + "static/AlgebraDisplayLight-b97c60655300f281b5582194301c9317.woff2";